// SvgIcon Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SvgIcon extends Component {
  static get propTypes () {
    return {
      name: PropTypes.string,
      className: PropTypes.string,
      size: PropTypes.string,
      onClick: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      name: '',
      className: '',
      size: '16',
      onClick: null
    }
  }

  render () {
    const { name, size, className, onClick } = this.props

    return (
      <svg
        fill='currentColor'
        viewBox='0 0 100 100'
        style={{ width: `${size}px`, height: `${size}px` }}
        className={`csvgicon${className ? ' ' + className : ''}`}
        onClick={onClick}
      >
        <use
          xlinkHref={`/svgicons/defs/svg/sprite.def.svg?v=1.0.116#icon-${name}`}
        />
      </svg>
    )
  }
}

export default SvgIcon
